import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button, Grid } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchDataDomain, updateDataDomain } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import { COMPANY_ID } from "../../config/appConfig";

export default function DataDomainEditPage() {
  const { businessDomainId, dataDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const [form, setForm] = useState({ dataDomainId: "", companyId: "", dataDomainName: "", dataDomainDescription: "" });

  useEffect(() => {
    (async () => {
      try {
        const d = await fetchDataDomain(dataDomainId);
        setForm({
          dataDomainId: d.dataDomainId || "",
          companyId: d.companyId || COMPANY_ID,
          dataDomainName: d.dataDomainName || "",
          dataDomainDescription: d.dataDomainDescription || "",
        });
      } catch (e) { notify.apiError(e); }
    })();
  }, [dataDomainId]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateDataDomain(form);
      notify.success(t("message.update.success"));
      navigate(`/design/${businessDomainId}/data-domains/${dataDomainId}`);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("dataDomain.edit.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField fullWidth required label={t("dataDomain.name")} name="dataDomainName" value={form.dataDomainName} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth multiline rows={3} label={t("common.description")} name="dataDomainDescription" value={form.dataDomainDescription} onChange={handleChange} />
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.save")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/design/${businessDomainId}/data-domains/${dataDomainId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
